<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { getCampaignList, getOtherCampaign, getOtherCampaignControlSotres } from "@/api/campaigns.js";

import {
  getMarketingRecommendations,
  getTotalSalesYoY,
  getCampaignVsControlStoresMastercard,
  getCampaignVsControlStoresPosdata
} from "@/api/analytics";
import { getIndex, setLocation } from "@/utils";
import LocalMarket from "@/view/components/campaign_analytics/LocalMarket.vue";
import ControlStores from "@/view/components/campaign_analytics/ControlStores.vue";
import ControlsDialog from "@/view/components/campaign_analytics/ControlsDialog.vue";

import MarketingRecommendations from "@/view/components/campaign_analytics/MarketingRecommendations.vue";
import KpiMetric from  "@/view/components/campaign_analytics/KpiMetric.vue";
import Portlet from  "@/view/components/campaign_analytics/Portlet.vue";
import ControlVsTestStores from "@/view/components/campaign_analytics/ControlVsTestStores.vue";
import moment from "moment";
import swal from "sweetalert";


const startOfMonth = moment()
  .subtract(1, "months")
  .startOf("month")
  .format("YYYY-MM-DD");

const endOfMonth = moment()
  .subtract(1, "months")
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "campaign-analytics",
  components: {
    VueCtkDateTimePicker,
    LocalMarket,
    MarketingRecommendations,
    KpiMetric,
    ControlStores,
    ControlsDialog,
    Portlet,
    ControlVsTestStores
  },
  data() {
    return {
      form: {
        selectedItems: [],
        dtpicker: { start: startOfMonth, end: endOfMonth },
        selectedCampaign: null,
        location: null,
        campaign: null,
        selectedYearOver: 1
      },
      yoyCategoryView: "These values are reported in Year over Year changes",
      overYearOption: [
        { text: "Absolute Value", value: 3},
        { text: "Year over Year", value: 1},
        { text: "Year over 2 Years", value: 2}
      ],
      locations: [],
      searchTerm: null,
      searchCampaign: null,
      locationsCopy: [],
      locationsOptions: [],
      campaigns: [],
      campaignsCopy: [],
      campaignsOptions: [],
      maxDisplay: 1,
      snackbar: false,
      text: "",
      timeout: 2000,
      vertical: true,
      locationsLoading: true,
      campaignsLoading: true,
      tabIndex: 0,
      active_tab: 0,
      isSearch: true,
      pos_metrics: [],
      region_metrics: [],
      marketing_recommendations: [],
      total_sales_yoy_data: [],
      show_controls_dialog: false,
      campaign_start_total_sales: {},
      campaign_end_total_sales: {},
      firstLoadDone: false,
      isNetworkData: false,
      isNetworkToggleDisabled: true,
      toggleLabel: "Network Data Only",
      itsNotAbsolute: true,
      disabledInAbsoluteValue: false,
      campaignVsControlStoresMastercarddata: [],
      campaignVsControlStoresPosdata: []
    };
  },
  async beforeMount() {
  },
  async mounted() {
    this.firstLoadDatePick();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Campaign Analytics" }]);
    // this.$store.commit("setLocationVisibile", false);
    const campaigns = await getCampaignList();
    if (campaigns) {
      this.campaigns = campaigns;
      console.log('=-=-=-=-=-=-: ', campaigns.length)
      if(campaigns.length <= 0 ){
        swal("No Campaigns are listed", "Please create atleast one.").then(() => {
          this.$router.push(`/campaigns`);
        });
        return;
      }
      
      setTimeout(() => {
        this.setCampaigns();
      }, 500);
    }
  },
  computed: {
    // likesAllItems() {
    //   return this.form.selectedItems.length === this.locationsOptions.length;
    // },
    // likesSomeItem() {
    //   return this.form.selectedItems.length > 0 && !this.likesAllItems;
    // },
    // icon() {
    //   if (this.likesAllItems) return "mdi-close-box";
    //   if (this.likesSomeItem) return "mdi-minus-box";
    //   return "mdi-checkbox-blank-outline";
    // },
    networkDataStatus() {
      return this.toggleLabel;
    }    
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    "form.selectedCampaign"() {
      this.setCampaignLocations();  
    },
    "form.dtpicker"(newVal) {
      if (newVal) {
        let start = newVal && newVal.start ? newVal.start : this.dtpicker.start;
        let end = newVal && newVal.end ? newVal.end : this.dtpicker.end;
        if (start == end) {
          let new_date = moment(start, "YYYY-MM-DD").add(1, "days");
          this.form.dtpicker = { start: start, end: new_date };
        }
      } else {
        // this.form.dtpicker = { start: startOfMonth, end: endOfMonth };
        let last365 = moment().subtract(1, "years");
        last365 = last365.format("YYYY-MM-DD");
        let today = moment();
        today = today.format("YYYY-MM-DD");

        this.form.dtpicker  = { start: last365, end: today };
      }
    },
    "form.selectedYearOver"(){
      this.itsNotAbsolute = true
      this.disabledInAbsoluteValue = false
      if (this.form.selectedYearOver === 3){
        this.itsNotAbsolute = false
        this.disabledInAbsoluteValue = true
        this.marketing_recommendations = []
      }
    },
    async "active_tab"(){
      if (this.form.campaign != null){
        this.isSearch = false;
        const responses = await Promise.all([
          getMarketingRecommendations({
            pos_id: null,
            campaign_id: this.form.campaign.id,
            is_network_data: this.isNetworkData,
            year_option: this.form.selectedYearOver,
            active_tab:this.active_tab
          }),        
        ]);

        this.marketing_recommendations = responses[0];
        if(this.active_tab=='control-stores'){
          this.triggerTestVsControlsSearch();
        }
        this.isSearch = true;
      }
    },
    
  },
  methods: {
    async setCampaignLocations() {
      // this.isSearch = false;
      this.locations = [];
      this.locationsOptions = [];
      let campaign_id = this.form.selectedCampaign.value;
      let item = await getOtherCampaign(campaign_id);
      console.log("Campaign Item", item);
      if (item && item.all_locations && item.all_locations.length) {
        this.locations = item.all_locations;
        this.form.campaign = item;
        // setTimeout(() => {
        //   this.setLocations();
        // }, 500);
      } else {
        this.snackbar = true;
        this.text = "No available locations recorded in this campaign";
      }
      // console.log("Selected tab:",this.active_tab)
      if (this.active_tab == "control-stores" ){
        let current_campaign_control_stores = await getOtherCampaignControlSotres(this.form.campaign.id);   
        let any_selected = false       
        for(let i=0;i<current_campaign_control_stores.control_stores.length;i++){
          if (current_campaign_control_stores.control_stores[i]['is_selected']==true){
            any_selected = true
          }
        }
        if (any_selected==false){
          swal("Notice", "Please save control stores for this campaign");
        }     
        
      }
    },
    async checkCampaignControlStores(){
      let current_campaign_control_stores = await getOtherCampaignControlSotres(this.form.campaign.id); 
      let any_selected = false       
      for(let i=0;i<current_campaign_control_stores.control_stores.length;i++){
        if (current_campaign_control_stores.control_stores[i]['is_selected']==true){
          any_selected = true
        }
      }
      if (any_selected==false){
        swal("Notice", "Please save control stores for this campaign");
      }
    },
    setLocations() {
      this.snackbar = true;
      this.text = "Loading locations...";
      this.locationsOptions = [
        ...this.locations.map((list) => {
          return {
            value: list.pos_id,
            text: `${list.name} ${list.full_address}`,
            name: list.name,
            full_address: list.full_address,
          };
        }),
      ];
      this.locationsCopy = [...this.locationsOptions];
      this.locationsLoading = false;

      let index = getIndex(this.locationsOptions);
      let selected = this.locationsOptions[index];

      setLocation(selected);
      this.form.selectedItems.push(selected);
      this.form.location = selected;
      this.onSearch();
    },
    capitalize(str) {
      if(!str){
        return ''
      }
      return (str = str
      .split(" ")
      .map(
        ([firstChar, ...rest]) =>
          firstChar.toUpperCase() + rest.join("").toLowerCase()
      )
      .join(" "));
    },
    setCampaigns() {
      this.campaignsOptions = [
        ...this.campaigns.map((item) => {
          if(item.name){
            return {
              value: item.id,
              text: this.capitalize(`${item.name}`),
              item: item,
            };
          }
        }),
      ];
      this.campaignsCopy = [...this.campaignsOptions];
      this.campaignsLoading = false;

      // let index = getIndex(this.campaignsOptions);
      // let selected = this.campaignsOptions[index];
      // this.form.selectedCampaign = selected;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.form.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item);
          }
          this.form.selectedItems = data;
        }
      });
    },
    // filterLocations() {
    //   if (!this.searchTerm) {
    //     this.locationsOptions = this.locationsCopy;
    //   }
    //   this.locationsOptions = this.locationsOptions.filter((item) => {
    //     return (
    //       item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
    //     );
    //   });
    // },
    filterCampaigns() {
      if (!this.searchCampaign || this.campaignsOptions.length == 0) {
        this.campaignsOptions = this.campaignsCopy;
      }
      this.campaignsOptions = this.campaignsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchCampaign.toLowerCase()) >
          -1
        );
      });
    },
    filterLocationsBlur(vl){
      this.searchCampaign = null
      this.filterCampaigns()
    },
    async onSearch() {
      if (!this.form.selectedCampaign) {
        swal("Notice", "Campaign is required");
        return false
      }
      
      this.isSearch = false;
      const payload = JSON.parse(
        JSON.stringify({
          // pos_id: this.form.location.value,
          pos_id: null,
          start_date: this.form.dtpicker.start,
          end_date: this.form.dtpicker.end,
          campaign_id: this.form.campaign.id,
          period: "day",
        })
      );

      const responses = await Promise.all([
        getMarketingRecommendations({
          // pos_id: this.form.location.value,
          pos_id: null,
          campaign_id: this.form.campaign.id,
          is_network_data: this.isNetworkData,
          year_option: this.form.selectedYearOver,
          active_tab:this.active_tab
        }),
        getTotalSalesYoY(payload, this.form.selectedYearOver),
        getCampaignVsControlStoresMastercard({
          start_date: this.form.dtpicker.start,
          end_date: this.form.dtpicker.end,
          campaign_id: this.form.campaign.id,
          year_option: this.form.selectedYearOver
        }),
        getCampaignVsControlStoresPosdata({
          start_date: this.form.dtpicker.start,
          end_date: this.form.dtpicker.end,
          campaign_id: this.form.campaign.id,
          year_option: this.form.selectedYearOver
        })

      ]);

      this.marketing_recommendations = responses[0];            
      this.total_sales_yoy_data = responses[1];
      
      try {
        if (responses[2].hasOwnProperty('control_stores')){
          for (let i = 0; i < responses[2]['control_stores'].length; i++) {
          responses[2]['control_stores'][i].date = (moment(responses[2]['control_stores'][i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
          }
        }
        if (responses[2].hasOwnProperty('test_stores')){
          for (let i = 0; i < responses[2]['test_stores'].length; i++) {
            responses[2]['test_stores'][i].date = (moment(responses[2]['test_stores'][i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
          }
        }
        if (responses[3].hasOwnProperty('control_stores')){
          for (let i = 0; i < responses[3]['control_stores'].length; i++) {
            responses[3]['control_stores'][i].date = (moment(responses[3]['control_stores'][i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
          }
        }
        if (responses[3].hasOwnProperty('test_stores')){
          for (let i = 0; i < responses[3]['test_stores'].length; i++) {
            responses[3]['test_stores'][i].date = (moment(responses[3]['test_stores'][i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
          }
        }
      } catch (error) {
        console.log(error)
      }
      this.campaignVsControlStoresMastercarddata = responses[2];
      this.campaignVsControlStoresPosdata = responses[3];
      if (this.total_sales_yoy_data && this.total_sales_yoy_data.length > 0) {
        this.isNetworkToggleDisabled = false;
      } else {
        this.isNetworkData = true;
        this.isNetworkToggleDisabled = true;
      }
      await this.triggerKpiMetricSearch();
      
      if(this.active_tab=='control-stores'){
        this.triggerTestVsControlsSearch();
      }
      
      this.triggerPortletSearch();      
      setTimeout(() => {
        this.isSearch = true;
         this.yoyCategoryView = `These values are reported in ${this.overYearOption[this.form.selectedYearOver - 1].text} changes `
      }, 2000);
      
    },
    handleClose() {
      this.show_controls_dialog = false;
    },
    firstLoadDatePick() {
      if (!this.firstLoadDone) {
        this.firstLoadDone = true;

        let current = new Date();

        let enddate = `${current.getFullYear()}-${current.getMonth() +
          1}-${current.getDate()}`;
        let startdate = `${current.getFullYear() - 1}-${current.getMonth() +
          1}-${current.getDate()}`;

        this.form.dtpicker.start = startdate; // this set the value of date picker //initial first load set date range
        this.form.dtpicker.end = enddate;
      }
    },
    whenDtClosed() {
      if (this.form.dtpicker.end == null && this.form.dtpicker.start != null) {
        this.form.dtpicker.end = this.form.dtpicker.start;
      }
    },
    
    async handleLegendSelectorChange(value){
      // console.log("Legend changed:",value);
      let payload_1 = {
          // pos_id: this.form.location.value,
          pos_id: null,
          campaign_id: this.form.campaign.id,
          is_network_data: this.isNetworkData,
          year_option: this.form.selectedYearOver,
          active_tab:this.active_tab
        }
      let payload = {...payload_1,...value[0]}
      this.isSearch = false;
      const responses = await Promise.all([
        getMarketingRecommendations(payload),        
      ]);
      this.marketing_recommendations = responses[0];            
      this.isSearch = true;
    },

    async toggleNetworkData(){
      console.log(`Network Data ${this.isNetworkData}`);
      let payload = {
          // pos_id: this.form.location.value,
          pos_id: null,
          campaign_id: this.form.campaign.id,
          is_network_data: this.isNetworkData,
          year_option: this.form.selectedYearOver,
          active_tab:this.active_tab
        }
      
      this.isSearch = false;
      const responses = await Promise.all([
        getMarketingRecommendations(payload),        
      ]);
      this.marketing_recommendations = responses[0];    
      if(this.active_tab=='control-stores'){
        this.triggerTestVsControlsSearch();
      }
      this.isSearch = true;        
    },
    async triggerKpiMetricSearch() {
      let componentEvent = this.$refs.kpiMetricMethod
      await componentEvent.fetchData()      
    },
    triggerPortletSearch() {
      let componentEvent = this.$refs.portletMethod
      componentEvent.onSearch()      
    },
    triggerTestVsControlsSearch(){
      let componentEvent = this.$refs.controlStoresMethod
      componentEvent.onSearch();
    },
    openControls(){
      if (!this.form.selectedCampaign){
        swal("Notice", "Campaign is required");
        return false
      }
      this.show_controls_dialog = true
    }
  },
};
</script>

<style scoped>
.subheader {
  background: #e9eaf3 !important;
}

.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}

.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}

.content-box {
  margin-top: 40px;
}
.toggle-box {
  position:absolute;
  right:20px;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}
.v-tooltip--bottom {
  background: white;
  color: black;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}

.option__title {
  font-size: 14px;
}

.option__small {
  font-size: 10px;
}

.v-text-field--outlined >>> fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.v-list {
  margin-top: 45px !important;
  width: 250px !important;
}
</style>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <!-- Subheader -->
      <div class="subheader d-flex align-items-center justify-content-center zindex-99">
        <div class="mr-2 mt-6" style="width: 250px;">
          <v-select
            label="Campaign"
            placeholder="Select Campaign"
            v-model="form.selectedCampaign"
            :items="campaignsOptions"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
            :loading="campaignsLoading"
            return-object
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchCampaign"
                    placeholder="Search"
                    @input="filterCampaigns"
                    @blur="filterLocationsBlur"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
        </div>
        <div class="mr-2 mt-6" style="width: 250px;">
          <v-select
            v-model="form.selectedYearOver"
            :items="overYearOption"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
            :menu-props="{ top: false, offsetY: true }"
          ></v-select>
        </div>
        <div class="mr-2" style="width: 270px;">
          <VueCtkDateTimePicker
            @is-hidden="whenDtClosed()"
            v-model="form.dtpicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select date range"
            range
          />
        </div>
        <!-- <div class="mr-2 mt-6" style="width: 250px;">
          <v-select
            v-model="form.selectedItems"
            :items="locationsOptions"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
            :loading="locationsLoading"
            return-object
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchTerm"
                    placeholder="Search"
                    @input="filterLocations"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>

              <v-divider class="mt-2"></v-divider>
            </template>

            <template slot="item" slot-scope="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.full_address }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div> -->
        <div class="mr-2">
          <v-btn
            md
            depressed
            color="primary"
            style="height:40px;"
            @click="openControls"
          >
            CONTROLS
          </v-btn>
        </div>
        <div>
          <v-btn
            md
            depressed
            color="primary"
            style="height:40px;"
            @click="onSearch()"
            :disabled="disabledInAbsoluteValue"
          >
            <v-icon> mdi-magnify</v-icon>
          </v-btn>
        </div>
      </div>
      <!-- Subheader end -->
      <!-- Content -->
      <div  class="content-box" >
        <!-- <v-card elevation="3" class="mt-20" > -->
        <!-- <v-card  class="mt-20" > -->
          <v-tabs
            v-model="active_tab"
            background-color="white"
            color="deep-purple accent-4"
            left
          >
            
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#local-market">Local Market</v-tab>
            <v-tab href="#control-stores" @click="checkCampaignControlStores">Control Stores</v-tab>
            <div class="toggle-box d-flex justify-end align-center">
               <v-switch
                  class="toggler-icon" 
                  v-model="isNetworkData"
                  @change="toggleNetworkData"
                  :disabled="isNetworkToggleDisabled"
                  inset
                  flat
                >
              </v-switch>
              <v-tooltip color="black" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="label-txt" 
                        v-bind="attrs"
                        v-on="on">{{networkDataStatus}}
                      </div>
                    </template>
                    <span>
                      Toggling on Network Data Only will remove your POS and payments data from the calculations 
                      for both Local Market and Control Store results. If you have not integrated to your POS or processor
                      then you can only use network data.
                    </span>
                  </v-tooltip>
            </div>
          </v-tabs>
            <v-tabs-items v-model="active_tab">
              <v-tab-item :value="'local-market'">
                <div>
                  <!-- v-if="" -->
                  <v-container fluid v-if="!isSearch" >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-container>
                  <marketing-recommendations 
                    :class="disabledInAbsoluteValue ? 'absolute-val-css' : ''"
                    :marketing_recommendations="marketing_recommendations"
                    :form="form"     
                    :isNetworkData="isNetworkData"
                    :campaignIsSearch="isSearch"
                    :active_tab="this.active_tab"
                    :disabledInAbsoluteValue="disabledInAbsoluteValue"  
                  ></marketing-recommendations>
                  <!-- <div class="card-separator" style="border-top: 2px solid #d4d9dd;margin: 30px 0;"></div> -->
                  <kpi-metric
                    :class="disabledInAbsoluteValue ? 'absolute-val-css' : ''"
                    :pos_metrics="pos_metrics"
                    :region_metrics="region_metrics"
                    :total_sales_yoy_data="total_sales_yoy_data"
                    :isNetworkData="isNetworkData"
                    :form="form"
                    @legendSelectors="handleLegendSelectorChange"      
                    :disabledInAbsoluteValue="disabledInAbsoluteValue"
                    ref="kpiMetricMethod"              
                  ></kpi-metric>
                  <Portlet
                  :isNetworkData="isNetworkData"
                  :formCampaign="form"
                  ref="portletMethod" 
                  >
                  </Portlet>
                </div>
                
                <!-- <v-container fluid>                
                  <local-market
                    v-if="isSearch"
                    :pos_metrics="pos_metrics"
                    :region_metrics="region_metrics"
                    :total_sales_yoy_data="total_sales_yoy_data"
                    :form="form"
                    :campaign_start_total_sales="campaign_start_total_sales"
                    :campaign_end_total_sales="campaign_end_total_sales"
                    :yoyCategoryView="yoyCategoryView"
                    @kpi="getKpi"
                    @overYearOptionSelected="getDataForSelectedYear"
                    :isNetworkData="isNetworkData"
                  ></local-market>
                </v-container> -->
              </v-tab-item>
              <v-tab-item :value="'control-stores'">
                <v-container fluid v-if="!isSearch">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-container>
                <v-container fluid>
                  <!-- <control-stores
                    v-if="isSearch"
                    :isNetworkData="isNetworkData"
                    :form="form"
                    :marketing_recommendations="marketing_recommendations"
                    :disabledInAbsoluteValue="disabledInAbsoluteValue"
                    :campaignIsSearch="isSearch"
                    :active_tab="this.active_tab"
                    :campaignVsControlStoresMastercarddata ="this.campaignVsControlStoresMastercarddata" 
                    :campaignVsControlStoresPosdata="this.campaignVsControlStoresPosdata"                                  
                    
                  ></control-stores> -->
                  <marketing-recommendations 
                    :class="disabledInAbsoluteValue ? 'absolute-val-css' : ''"
                    :marketing_recommendations="marketing_recommendations"
                    :form="form"     
                    :isNetworkData="isNetworkData"
                    :campaignIsSearch="isSearch"
                    :active_tab="this.active_tab"
                    :disabledInAbsoluteValue="disabledInAbsoluteValue"  
                  ></marketing-recommendations>
                  <control-vs-test-stores
                    :form="form"     
                    :isNetworkData="isNetworkData"
                    :campaignIsSearch="isSearch"
                    :active_tab="this.active_tab"
                    :disabledInAbsoluteValue="disabledInAbsoluteValue"
                    :campaignVsControlStoresMastercarddata ="this.campaignVsControlStoresMastercarddata" 
                    :campaignVsControlStoresPosdata="this.campaignVsControlStoresPosdata"
                    ref="controlStoresMethod"
                  ></control-vs-test-stores>
                </v-container>
              </v-tab-item>
            </v-tabs-items>          
            
          
        <!-- </v-card> -->
      </div>
      
      <!-- Content end -->
      <v-snackbar
        v-model="snackbar"
        :vertical="vertical"
        content-class="background:red"
        color="danger"
        dark
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <controls-dialog
        v-if="show_controls_dialog"
        :show="show_controls_dialog"
        :formCampaign="form"
        :campaignLocations="locations"
        @close="handleClose"
      ></controls-dialog>
    </v-main>
  </v-app>
</template>

<style scoped>

.v-tooltip__content {
    width: 50vw !important;
    left: auto !important;
    right: 30px !important;
}
.label-txt{
  color: rgba(0,0,0,.6);
  font-size: 16px;
  padding-bottom: 3px;
  right: 4px;
  bottom: 5px;
  position: relative;
}
.toggler-icon{
  margin-top: 5px;
}
.zindex-99{
  position: relative;
  z-index: 10;
}
</style>